
import { PAUSED } from '@Config/scenes';

/*--------------- Scenes ------------------*/
import BaseScene from '@Scenes/BaseScene';

/*--------------- Networks ------------------*/

/**
 * Score Scene,
 * Displays score and tricks
 */
class PausedScene extends BaseScene
{
    constructor()
    {
        super(PAUSED);
    }

    /**
     * Create
     */
    public create()
    {
        const gameSize = this.getGameSize();

        const fontStyle = { fontFamily: 'Permanent Marker', color: '#000000', fontSize: '25px' };

        const pausedText = this.add.text(gameSize.width / 2, gameSize.height / 2, 'Paused', fontStyle);
        pausedText.setOrigin(0.5);
        pausedText.setAlign('center');

        this.cameras.main.setBackgroundColor('rgba(255,255,255,0.9)');
    }
}

export default PausedScene